<div class="page-container" style="min-height:188.38330078125px">
  <!--Page content -->
  <div class="page-content text-center">
    <div class="panel panel-flat shadow" style="border: none">
      <div class="panel-body">
        <form #form="ngForm" novalidate>
          <div class="row">
            <br>
            <div class="row">
              <div class="col col-sm-8 col-sm-offset-2 col-xs-10 col-xs-offset-1">
                <div class="form-group position">
                  <label class="col-sm-4 col-xs-5 text-right "><strong translate>Verification Code</strong></label>
                  <div class="col-sm-5 col-xs-6 text-left">
                    <input type="text" class="form-control" [(ngModel)]="accessCode" [placeholder]="'Verification Code...' | translate" name="code" #code="ngModel" required minlength="8" maxlength="15" pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ0-9]*)$">
                  </div>
                </div>
              </div>
            </div>
            <br><br>
            <div class="row">
              <div class="col col-sm-8 col-sm-offset-2 col-xs-10 col-xs-offset-1">
                <p class="text-justify" translate>It is a legal responsibility to perform this process (verification) for those who do not have access to the verification service provided by the inquiry service.</p>
              </div>
            </div>
            <div class="row">
              <div class="col col-sm-6 col-sm-offset-3 col-xs-8 col-xs-offset-2">
                <div class="form-group">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" [(ngModel)]="isUserChecked" name="isActive" #isActive="ngModel">
                      {{translate.instant('I have read and I accept the above text informational')}}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <button type="button" class="btn btn-default active" (click)="verifyDocument()" [disabled]=" !form.valid || !isUserChecked" data-dismiss="modal" translate>Verify Document</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
